import * as Sentry from '@sentry/vue';
import { ILASDefaultDataSource } from '@xeokit/xeokit-sdk';
import { LASDefaultDataSource } from '@xeokit/xeokit-sdk/src/plugins/LASLoaderPlugin/LASDefaultDataSource.js';

export class DataSourceLAS extends LASDefaultDataSource implements ILASDefaultDataSource {
  cacheBuster: boolean = false;

  constructor(cfg: any = {}) {
    super(cfg);
    this.cacheBuster = cfg.cacheBuster !== false;
  }

  _cacheBusterURL(url: string) {
    if (!this.cacheBuster) {
      return url;
    }
    const timestamp = new Date().getTime();
    if (url.indexOf('?') > -1) {
      return url + '&_=' + timestamp;
    } else {
      return url + '?_=' + timestamp;
    }
  }

  getLAS(src: string | number, ok: (buffer: ArrayBuffer) => void, error: (e: Error) => void) {
    const defaultCallback = () => {};
    ok = ok || defaultCallback;
    error = error || defaultCallback;

    const processesStore = useProcessesStore();
    const config = useRuntimeConfig();

    const dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
    const dataUriRegexResult = (src as string).match(dataUriRegex);
    if (dataUriRegexResult) {
      // Safari can't handle data URIs through XMLHttpRequest
      const isBase64 = !!dataUriRegexResult[2];
      let data = dataUriRegexResult[3];
      data = window.decodeURIComponent(data);
      if (isBase64) {
        data = window.atob(data);
      }
      try {
        const buffer = new ArrayBuffer(data.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < data.length; i++) {
          view[i] = data.charCodeAt(i);
        }
        ok(buffer);
      } catch (errMsg: any) {
        Sentry.captureException(error, {
          fingerprint: ['data-source-las', 'getLAS', src as string],
        });
        error(errMsg);
      }
    } else {
      const request = new CachedXHR(config.public.URL_EXP_TIME * 1000);
      request.open('GET', this._cacheBusterURL(src as string), true);

      request.onprogress = function (event: ProgressEvent) {
        if (event.lengthComputable) {
          processesStore.updateDownloadProgress(src as string, event.loaded, event.total);
        }
      };

      request.onabort = function (event: ProgressEvent) {
        const error = new Error('Download aborted');
        processesStore.updateDownloadProgress(src as string, event.loaded, event.total, error);
      };

      request.ontimeout = function (event: ProgressEvent) {
        const error = new Error('Download timeout');
        processesStore.updateDownloadProgress(src as string, event.loaded, event.total, error);
      };

      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status !== 200) {
            const xktError = new Error('getLAS error : ' + request.response);
            error(xktError);
          }
        }
      };

      request.addEventListener('finish', async (event: Event) => {
        const blob = (event as CustomEvent).detail as Blob;
        ok(await blob.arrayBuffer());
      });

      request.send(null);
    }
  }
}
